export const SIZE: number = 5
export const PAGE: number = 0
